import axios from 'axios'
import * as end from 'constants/api'
import { axiosInstance } from 'services/axios-instance'

const AccountServices = {
	getDocumentTypePublic: () => axios.get(end.getDocumentTypePublic).then(res => res.data),
	getDocumentType: () => axiosInstance.get(end.getDocumentType).then(res => res.data),
	registerUser: ({ payload }) => axiosInstance.post(end.newRegister, payload).then(res => res.data),
	updateUserInfo: ({ userId, payload }) =>
		axiosInstance.put(end.updateUserInfo({ userId }), payload).then(res => res.data),
	updateCareStatus: payload =>
		axiosInstance.post(end.updateCareStatus, payload).then(res => res.data),
	updateOnboarding: ({ userId, payload = false }) =>
		axiosInstance.post(end.updateOnboardingPrograms({ userId }), payload).then(res => res.data),
	updateUserKutai: ({ payload, userId }) =>
		axiosInstance.put(end.updateUserInfo({ userId }), payload).then(res => res.data),
	updateOnboardingInitial: ({ payload, userId }) =>
		axiosInstance.put(end.updateUserOnboardingInitial({ userId }), payload).then(res => res.data),
	getBenefits: ({ userId, idBenefit }) =>
		axiosInstance.get(end.getBenefitsUser({ userId, idBenefit })).then(res => res.data),
	saveBenefits: ({ userId, payload }) =>
		axiosInstance.post(end.saveBenefitsUser({ userId }), payload).then(res => res.data),
	getKutaiPrograms: () => axiosInstance.get(end.getKutaiPrograms).then(res => res.data),
	getAddonsAvailables: ({ userId }) =>
		axiosInstance.get(end.getAddonsAvailables({ userId })).then(res => res.data)
}

export default AccountServices
